
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import timestatistical from "./components/timestatistical.vue"
  import lineCharts from "./components/line-charts.vue"
  import columnCharts from "./components/column-charts.vue"
  import column3Charts from "./components/column3-charts.vue"
	import {
    getSearchDate,
		nextDay
	} from "@/utils"
  import {defaultHeader} from "@/utils/config"
  import {
    dataStatisdataStatisMemberTeamAnalysisSevenDaySell,
    dataStatisdataStatisMemberTeamAnalysisInfo,
    dataStatisdataStatisMemberTeamProductSellAnalysis,
    dataStatisdataStatisMemberTeamSingleProductAnalysis,
    dataStatisMemberTeamoverview,
    dataStatisMemberTeamoverviewList
  } from "@/api/material"
  
  import {
    productCategory,
  } from '@/api/supplier'
  @Component({  
    name: '',
    components: {
      PageFooter,
      timestatistical,
      lineCharts,
      columnCharts,
      column3Charts
    }
  })

  export default class ProductList extends Vue {
    private up = 'http://cdn2024.routuan.com/routuan/image/dataAnalysis-up.png'
    private down = 'http://cdn2024.routuan.com/routuan/image/dataAnalysis-down.png'
    private greenup = 'http://cdn2024.routuan.com/routuan/image/greenup.png'
    private reddown = 'http://cdn2024.routuan.com/routuan/image/reddown.png'
    private defaultHeader = defaultHeader
    private lineChartList:any = []
    private lines1:any = [
      {key:'value',name:'213'}
    ]
    private type1 = 1;
    private time1:any = []
    private overviewmsg:any = {}
    private compare = [
      {type:1,label:'较前一日'},
      {type:2,label:'较前一周'},
      {type:3,label:'较前一月'},
      {type:4,label:'较前7天'},
      {type:5,label:'较前30天'},
    ]
    private tablelist:any = []
    private tableloading = false
    private keywords = ''
    private total = 0
    private pageNo = 1
    private pageSize = 10
    private gainsloading = false
    private gainslist:any = []
    private overviewloading = false
    private overviewcharts:any = []
    private linesoverview:any = []
    private overviewchartsloading = false
    private keywords2 = ''
    private classity = ''
    private classitylist:any = []
    private tablelist2:any = []
    private tableloading2 = false
    private total2 = 0
    private pagesize2 = 10
    private currentPage = 1

    private defaultsort:any = {
      prop:'OrderGroupPrice',
      order:'descending'
    }

    private mounted () {
      // console.log(defaultHeader)
      this.time1 = getSearchDate(2)
      // this.time2 = getSearchDate(2)
      
    }
    activated () {
      this.getteamgains()
      this.getData()
      // this.todetailanalyse({MemberId:0})
    }



    private exportFile(){
      let url = location.origin + '/pc/dataStatis/dataStatisMemberTeamAnalysisInfoExport?'
      let data:any = {
        TimeType:this.type1,
        StartDate:this.time1[0],
        EndDate:this.time1[1],
        Name:this.keywords,
      }
      //如果查的是今天 type为0 时间为空
      let istoday = new Date(this.time1[0]).getTime()==new Date(getSearchDate(2)[0]).getTime()
      if(this.type1==1&&istoday){
        data.TimeType = 0
        data.StartDate = ''
        data.EndDate = ''
      }
      let argument = Object.keys(data).map(v=>{
        return `${v}=${data[v]}`
      }).join('&')
      window.open(url+argument)
    }
    private todetailanalyse(row){
      this.$router.push({
        path:'detailTeam',
        query:{
          Id:row.MemberId,
          name:row.Name,
          time:this.time1.join('/'),
          type:String(this.type1)
        }
      })
    }

    private sortmethod(col){
      // if(col.order){
        this.defaultsort = {
          prop:col.prop,
          order:col.order
        }
      // }else{
      //   this.defaultsort = {
      //     prop:'SubmitProductCount',
      //     order:false
      //   }
      // }
      this.gettablelist()
    }

    private gettime(e,num){
      let type = 'type' + num
      let time = 'time' + num
      this[type] = e.type
      this[time] = e.time
      this.pageNo = 1
      this.getData()
    }
    private getData(){
      // this.getteamoverview()
      // this.getteamoverviewcharts()
      this.gettablelist()
      // this.getList()
      // this.gettablelist2()
    }
    private handleCurrentChange(e){
      this.pageNo = e
      this.gettablelist()
    }
    private noinus(num:number){
      if(num<0){
        let str = num+''
        return str.substring(1,str.length)
      }
      return num || 0
    }
    //销售涨幅分析
    private async getteamgains(){
      try{
        this.gainsloading = true
        let res = await dataStatisdataStatisMemberTeamAnalysisSevenDaySell({})
        if(res.IsSuccess){
          let alllist = res.Result.map(v=>{
            v.Date = v.Name
            return v
          })

          let upthirtylist:any = alllist.filter(v=>{
            return v.OrderCustomerChangeRate>0
          }).sort((a,b)=>{
            return b.OrderCustomerChangeRate-a.OrderCustomerChangeRate
          })
          let upthirty:any = {
            type:1,
            title:'增长团队',
            tips:'近七日下单金额同比上个七日上升比例，展示前10名',
            explain:'上涨最高',
            img:this.greenup,
            name:upthirtylist[0]?.Name,
            headurl:upthirtylist[0]?.WxHeadUrl,
            teamnum:upthirtylist.length,
            list:upthirtylist.filter((v,i)=>{
              return i<10
            }),
            lines:[
              {key:'OrderCustomerChangeRate',name:'下单金额涨幅'}
            ]
          }
          let downtwentylist:any = alllist.filter(v=>{
            return v.OrderCustomerChangeRate<0
          }).sort((a,b)=>{
            return a.OrderCustomerChangeRate-b.OrderCustomerChangeRate
          })
          let downtwenty:any = {
            type:3,
            title:'下降团队',
            tips:'近七日下单金额同比上个七日下降比例，展示10名',
            explain:'下降较多',
            img:this.reddown,
            name:downtwentylist[0]?.Name,
            headurl:downtwentylist[0]?.WxHeadUrl,
            teamnum:downtwentylist.length,
            list:downtwentylist.filter((v,i)=>{
              return i<10
            }),
            lines:[
              {key:'OrderCustomerChangeRate',name:'下单金额涨幅'}
            ]
          }

          
          // let smoothlistup:any = alllist.filter(v=>{
          //   return v.OrderCustomerChangeRate>0 && v.OrderCustomerChangeRate<=10
          // }).sort((a,b)=>{
          //   return b.OrderCustomerChangeRate-a.OrderCustomerChangeRate
          // })
          // let smoothup:any = {
          //   type:2,
          //   title:'平稳上升团队',
          //   tips:'下单金额上升10%以内，展示前10名',
          //   explain:'',
          //   img:'',
          //   name:smoothlistup[0]?.Name,
          //   headurl:smoothlistup[0]?.WxHeadUrl,
          //   teamnum:smoothlistup.length,
          //   list:smoothlistup.filter((v,i)=>{
          //     return i<10
          //   }),
          //   lines:[
          //     {key:'OrderCustomerChangeRate',name:'下单金额涨幅'}
          //   ]
          // }
          // let smoothlistdown:any = alllist.filter(v=>{
          //   return v.OrderCustomerChangeRate>=-10 && v.OrderCustomerChangeRate<0
          // }).sort((a,b)=>{
          //   return a.OrderCustomerChangeRate-b.OrderCustomerChangeRate
          // })
          // let smoothdown:any = {
          //   type:2,
          //   title:'略微下降团队',
          //   tips:'下单金额下降10%以内，展示前10名',
          //   explain:'',
          //   img:'',
          //   name:smoothlistdown[0]?.Name,
          //   headurl:smoothlistdown[0]?.WxHeadUrl,
          //   teamnum:smoothlistdown.length,
          //   list:smoothlistdown.filter((v,i)=>{
          //     return i<10
          //   }),
          //   lines:[
          //     {key:'OrderCustomerChangeRate',name:'下单金额涨幅'}
          //   ]
          // }
          


          this.gainslist = [upthirty,downtwenty]

          // console.log(this.gainslist)
        }
      }finally{
        this.gainsloading = false
      }
    }
    //概览
    private async getteamoverview(){
      try{
        this.overviewloading = true
        let data:any = {
          TimeType:this.type1,
          StartDate:this.time1[0],
          EndDate:this.time1[1]
        }
        let res = await dataStatisMemberTeamoverview(data)
        if(res.IsSuccess){
          // console.log(res)
          this.overviewmsg = res.Result
        }
      }finally{
        this.overviewloading = false
      }
    }
    //概览折线图
    private async getteamoverviewcharts(){
      try{
        this.overviewchartsloading = true
        let data:any = {
          TimeType:this.type1,
          StartDate:this.time1[0],
          EndDate:this.time1[1]
        }
        let res = await dataStatisMemberTeamoverviewList(data)
        if(res.IsSuccess){
          // console.log(res)
          this.overviewcharts = res.Result.map(v=>{
            v.Date = v.StatisEndDate
            return v
          })
          this.linesoverview = [
            {key:'SubmitOrderMemberCount',name:'下单人数',defaultshow:true},
            {key:'SubmitOrderCount',name:'订单数量',defaultshow:true},
            {key:'SubmitOrderMoney',name:'下单金额',defaultshow:false},
          ]
        }
      }finally{
        this.overviewchartsloading = false
      }
    }
    //团队代理、订单数据
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          TimeType:this.type1,
          StartDate:this.time1[0],
          EndDate:this.time1[1],
          Name:this.keywords,
          // Skip:(this.pageNo-1)*this.pageSize,
          // Take:this.pageSize,
          Skip:0,
          Take:999999,
          // Sort:this.defaultsort.prop,
          // IsAsc:this.defaultsort.order=='ascending'?true:false
        }
        //如果查的是今天 type为0 时间为空
        let istoday = new Date(this.time1[0]).getTime()==new Date(getSearchDate(2)[0]).getTime()
        if(this.type1==1&&istoday){
          data.TimeType = 0
          data.StartDate = ''
          data.EndDate = ''
        }
        // console.log(data)
        let res = await dataStatisdataStatisMemberTeamAnalysisInfo(data)
        if(res.IsSuccess){
          // console.log(res)
          this.tablelist = res.Result.Results.map(v=>{
            let price = v.CheckOrderCount==0?'0':(v.OrderActualPrice/v.CheckOrderCount).toFixed(2)
            //已审核订单笔单价
            v.Pentheunitprice = price=='NaN'?0:price
            //新增人数
            v.newnumber = v.AddThirdRoleMemberCount+v.AddTwoRoleMemberCount
            //代理自购
            v.agentpurchase = (v.MemberOrderCount/v.OrderCount).toFixed(0)=='NaN'?0:(v.MemberOrderCount/v.OrderCount*100).toFixed(2)
            //代客下单
            v.valetorder = (v.MemberHelpCustomerOrderCount/v.OrderCount).toFixed(0)=='NaN'?0:(v.MemberHelpCustomerOrderCount/v.OrderCount*100).toFixed(2)
            //客户下单
            v.clientorder = (v.CustomerOrderCount/v.OrderCount).toFixed(0)=='NaN'?0:(v.CustomerOrderCount/v.OrderCount*100).toFixed(2)
            return v
          }).sort((a,b)=>{
            if(this.defaultsort.order=='ascending'){
              return a[this.defaultsort.prop] - b[this.defaultsort.prop]
            }else if(this.defaultsort.order=='descending'){
              return b[this.defaultsort.prop] - a[this.defaultsort.prop]
            }
          }).filter((v,i)=>{
            return i>=(this.pageNo-1)*this.pageSize&&i<this.pageNo*this.pageSize
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
